<template>
  <div class="accordion">
    <div class="accordionHeader" @click="toggleShow()" :class="{ show: show}" tabindex="0" @keydown.enter="toggleShow()" @keydown.space="toggleShow()">
      <slot name="heading">
        <span v-text="heading"></span>
      </slot>
    </div>
    <div v-if="shownOnce" v-show="show" class="accordionContent" :class="{ 'accordion-expanded': show }">
      <slot :show="show" :doToggle="doToggle" :doHide="doHide" :doShow="doShow"></slot>
    </div>
  </div>
</template>

<script lang="ts">

import {validationGroupProvInjFactory} from "../validation/ValidationGroup";

/**
 * Teil einer Accordion-Group
 * 
 * Eigenschaften:
 * heading: HTML-Content des Headers
 * initShow: Bool: Soll dieser Header initial angezeigt werden.
 * 
 * Slots: 
 *   - Die Component bekommt einen slot übergeben. Dieser wird als Inhalt des Accordions angezeigt
 *   - Die Slots können folgende Eigenschaften nutzen:
 *      show: Bool - Wird diees Accordion gerade angezeigt?
 *      doToggle: Function - Sichtbarkeit des Accordion umschalten
 *      doHide: Function - Accordion soll nicht angezeigt werden.
 *      doShow: Function - Accordion soll angezeigt werden.
 * 
 * Event:
 *  @show wird aufgerufen, wenn das Accrodion nach dem Ausblenden angezeigt wird
 *  @hide wird aufgerufen, wenn das verborgen wird
 * 
 * Beispiel für die Anwendung der Slots: Wenn NewSachbericht ein created-Event wirft, soll das Accordion geschlossen werden.
   <Accordion heading="Sachbericht/Abschlussbericht"  v-slot="{doHide}">
     <NewSachbericht @created="doHide()" />
   </Accordion>
 */

import { inject, shallowRef, onUnmounted,watch, PropType, nextTick} from "vue";
export default {
  props:{
    heading: String,
    initShow: {
      type: Boolean,
      default: false
    },
    errorIdentifier: [String, Array] as PropType<string | string[]>,
    eager: {
      type: Boolean,
      default: false
    }
  },
  emits:["show", "hide"],

  setup(props, { emit }){
    const group = inject("accordionGroup", null);
    const show = shallowRef(props.initShow);
    const shownOnce = shallowRef(props.initShow || props.eager);
    const obj = {
      heading: props.heading,
      hide(){
        show.value = false;
      }
    }
    if(group){
      group.addAccordion(obj);
      onUnmounted(()=>{
        group.removeAccordion(obj);
      });
    }

    

    const valGroup = validationGroupProvInjFactory()
    
    valGroup.callCallbacks = async () => {
      show.value = true;
      await nextTick();
    }

    watch(() => props.errorIdentifier, (val) => {
      if(val instanceof Array){
        valGroup.errorIdentifier.value = val;
      }
      else{
        valGroup.errorIdentifier.value = [val];
      }
    });
      
    return {
      doShow: () => show.value=true,
      doHide: () => show.value=false,
      doToggle: () => show.value=!show.value,
      show,
      shownOnce,
      toggleShow() {
        shownOnce.value = true;
        show.value = !show.value;
        emit(show.value ? "show" : "hide");
        if(group && show.value){
          group.activate(obj);
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.accordion {
  
}


</style>